/* eslint-disable */
let state = {

};

export default state;



// WEBPACK FOOTER //
// ./src/state.js